// Map shift color category -> Tailwind classes.
//
// User-approved palette (Feb 2026): keep regular work shifts NEUTRAL (white)
// so managers only see colour when something needs attention. Only Absent /
// PTO pending / PTO approved / LOA / Coverage / Unavailable / Open / Empty
// use accent colours. See the on-screen legend in the Schedule tab for the
// canonical mapping.
export const COLOR_MAP = {
  regular:          { bg: "bg-white",       text: "text-slate-800",   border: "border-slate-200"   },
  pto_blue:         { bg: "bg-sky-100",     text: "text-sky-800",     border: "border-sky-300"     },
  // #FF99FF exact — used for PTO REQUESTED (pending). Cells still show the
  // employee's original shift code (via prev_shift_code in the renderer) so
  // managers can tell what would be uncovered if approved.
  pending_magenta:  { bg: "bg-[#FF99FF]",   text: "text-fuchsia-900", border: "border-fuchsia-500" },
  absent_red:       { bg: "bg-red-100",     text: "text-red-800",     border: "border-red-300"     },
  unavail_purple:   { bg: "bg-purple-100",  text: "text-purple-800",  border: "border-purple-300"  },
  loa_grey:         { bg: "bg-slate-700",   text: "text-white",       border: "border-slate-800"   },
  training_orange:  { bg: "bg-orange-200",  text: "text-orange-900",  border: "border-orange-500"  },
  open_shift:       { bg: "bg-amber-100",   text: "text-amber-800",   border: "border-amber-300"   },
  coverage_pink:    { bg: "bg-pink-100",    text: "text-pink-800",    border: "border-pink-300"    },
  offered_green:    { bg: "bg-emerald-100", text: "text-emerald-800", border: "border-emerald-300" },
  ot_red:           { bg: "bg-red-50",      text: "text-red-800",     border: "border-red-300"     },
  // #FFCCFF exact — used for any approved hour modification (arrive late,
  // leave early, long lunch, left-sick-early partial absence). Softer than
  // the pending-PTO magenta so the two states stay visually distinct.
  mod_pink:         { bg: "bg-[#FFCCFF]",   text: "text-fuchsia-900", border: "border-fuchsia-300" },
  empty:            { bg: "bg-white",       text: "text-slate-300",   border: "border-slate-200"   },
};

export function colorForShift(shift) {
  if (!shift) return COLOR_MAP.empty;
  if (shift.color && COLOR_MAP[shift.color] && shift.color !== "regular") {
    return COLOR_MAP[shift.color];
  }
  // All numeric/named work codes render neutral (white) — the legend at the
  // top of the Schedule tab explains the full palette.
  return COLOR_MAP.regular;
}

export function shiftLabel(shift) {
  if (!shift) return "";
  const hrs = shift.start && shift.end ? `${shift.start}–${shift.end}` : `${shift.hours}h`;
  return `${shift.label} · ${hrs}`;
}
